
import QASection from '../components/QASection';
import Testimonials from '../components/Testimonials';
import VideoBackground from '../components/VideoBackground';
import Logo from '../components/Logo';
import WhoWeAre from '../components/WhoWeAre';
import ToolsSection2 from '../components/ToolsSection2';
import TeamSection from '../components/TeamSection';
function AboutUs() {
  

  return (
    <>
      <VideoBackground/>
      <Logo/>
      <WhoWeAre/>
      
 
      <ToolsSection2/>
      {/* <TeamSection/> */}
      <QASection/>
      
    </>  
  );
}

export default AboutUs;